import { render, staticRenderFns } from "./WizardDragZone.vue?vue&type=template&id=3e54036e&scoped=true&"
import script from "./WizardDragZone.vue?vue&type=script&lang=js&"
export * from "./WizardDragZone.vue?vue&type=script&lang=js&"
import style0 from "./WizardDragZone.vue?vue&type=style&index=0&id=3e54036e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e54036e",
  null
  
)

export default component.exports